import type { HTMLAttributes } from "react";

interface ProgressBarProps extends HTMLAttributes<HTMLDivElement> {
  value: number;
  max?: number;
  variant?: "flat" | "gradient";
}

export function ProgressBar({ value, max = 100, variant = "flat", className = "", ...props }: ProgressBarProps) {
  const boundedMax = max <= 0 ? 1 : max;
  const percent = Math.max(0, Math.min(100, Math.round((value / boundedMax) * 100)));

  return (
    <div className={`mmm-progress-bar mmm-progress-bar--${variant} ${className}`.trim()} {...props}>
      <div className="mmm-progress-bar__fill" style={{ width: `${percent}%` }} />
    </div>
  );
}
